
import React from "react";
import { styled } from "@mui/material/styles";
import { Box, Typography, Button } from "@mui/material";

const Wrapper = styled(Box)(({ theme }) => ({
  minHeight: "100vh",
  minWidth: "100vw",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: theme.spacing(4),
  textAlign: "center",
  backgroundColor: theme.palette.background.default,
}));

const Logo = styled('img')(({ theme }) => ({
  marginBottom: 20,
  height: 100,
}));

export default function MaintenancePage({ onRetry }) {
  return (
    <Wrapper>
      <Logo src={'WCA-HeaderLogo.png'} alt={'WCA logo'} />
      <Typography variant="h3" gutterBottom>
        Maintenance In Progress
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 600, mb: 1 }}>
        portal.wca.com is currently undergoing scheduled maintenance to improve performance and reliability.
        Please check back soon. Thanks for your patience!
      </Typography>
      <Typography variant="caption" color="text.secondary" sx={{ mt: 2, mb: 3 }}>
        Scheduled to complete on [insert date/time here].
      </Typography>
        {onRetry && (
        <Button variant="contained" color="primary" onClick={onRetry}>
          Refresh
        </Button>
      )}
    </Wrapper>
  );
}
